// @ts-nocheck
import * as React from 'react';

import { observer } from 'mobx-react';
import styled from 'styled-components';

import { RouterStore, RouterView, ViewMap } from '@estee/elc-router';

import {
    ACCOUNT_GUEST_CHECKOUT_ROUTE,
    ACCOUNT_SIGN_IN_ROUTE,
    ACCOUNT_SIGN_UP_ROUTE,
    CONSENT_ROUTE,
    IN_STORE_SIGN_UP_ROUTE,
    QRCODE_ROUTE,
    REDIRECT_ROUTE,
    SIGNUP_ROUTE,
    SOCIAL_SIGN_UP_ROUTE,
    SOCIAL_SIGN_UP_SUCCESS_ROUTE,
    SUCCESS_ROUTE
} from '~routes/routes';
import { classes } from '~utils/Classes';

import AccountAccessPage from './account/AccountAccessPage';
import { ConsentForm } from './account/ConsentForm';
import { UserSessionSuspense } from './common/UserSessionSuspense';
import { QRCode } from './qrcode/QRCode';
import { Redirect } from './redirect/Redirect';
import { SignUp } from './signup/SignUp';
import { RegisterSuccessPage } from './social-sign-up/RegisterSuccess';
import { SuccessPage } from './TestViews';

interface IRampRouterProps {
    className?: string;
    routerStore: RouterStore;
}

@observer
export class RampRouter extends React.Component<IRampRouterProps> {
    private viewMap: ViewMap;

    wrapWithUserSessionSuspense = (component: JSX.Element) => (
        <UserSessionSuspense>{component}</UserSessionSuspense>
    );

    constructor(props: IRampRouterProps) {
        super(props);

        const accountAccessPage = this.wrapWithUserSessionSuspense(<AccountAccessPage />);
        const signUpPage = this.wrapWithUserSessionSuspense(<SignUp />);

        // There's a logic which checks if there's signed user userId
        const socialConsentPage = this.wrapWithUserSessionSuspense(<ConsentForm />);

        this.viewMap = {
            // In-store sign-up form won't handle redirection hence no need to check existing session.
            [IN_STORE_SIGN_UP_ROUTE]: <SignUp />,
            [SOCIAL_SIGN_UP_ROUTE]: signUpPage,
            [SIGNUP_ROUTE]: signUpPage,
            [CONSENT_ROUTE]: socialConsentPage,
            [ACCOUNT_SIGN_IN_ROUTE]: accountAccessPage,
            [ACCOUNT_SIGN_UP_ROUTE]: accountAccessPage,
            [ACCOUNT_GUEST_CHECKOUT_ROUTE]: accountAccessPage,
            [QRCODE_ROUTE]: <QRCode />,
            [SUCCESS_ROUTE]: <SuccessPage />,
            [SOCIAL_SIGN_UP_SUCCESS_ROUTE]: <RegisterSuccessPage />,
            [REDIRECT_ROUTE]: <Redirect />
        };
    }

    public render() {
        const { routerStore, className } = this.props;
        const classNames = classes('iam-wrapper', className);
        const { mobxStateRouter } = routerStore;

        return (
            <div className={classNames} role="main">
                <RouterView routerStore={mobxStateRouter} viewMap={this.viewMap} />
            </div>
        );
    }
}
